import { Label, ModalPopup, Tooltip } from "client/CommonComponents";
import moment from "moment";
import Delete from "../../../../assets/images/Delete.svg";
import "./MyNotification.scss";
import { DATE_FORMAT } from "client/utils/constants";
import LoadingWrapper from "../../../../CommonComponents/LoadingWrapper"

interface IProps {
  myNotificationDetails?: any;
  onDeleteConfirm?: any;
  setDeletePopup?: any;
  deletePopup?: any;
  clearAllOnClick?: any;
  onDeleteAllNotificationConfirmation?: any;
  deleteAllNotifications ?: any;
  setDeleteAllNotification?: any;
  setNoNotificationAlertFlag?: any;
  noNotificationAlertFlag?: any;
  isLoading: boolean
}
const MyNotification = ({
  myNotificationDetails,
  onDeleteConfirm,
  deletePopup,
  setDeletePopup,
  clearAllOnClick,
  onDeleteAllNotificationConfirmation,
  deleteAllNotifications,
  setDeleteAllNotification,
  setNoNotificationAlertFlag,
  noNotificationAlertFlag,
  isLoading
}: IProps) => {
  return (
    <>
      <div className="my-alert-block my-notification-block">
        <div className="mb-1 top-section">
          <p className="heading">
            MY NOTIFICATIONS{" "}
            {myNotificationDetails?.notificationCount
              ? `(${myNotificationDetails?.notificationCount})`
              : ""}
          </p>
          <a href='/' className={myNotificationDetails?.notificationCount > 0 ? "clear-all" : "disable-Clear-all clear-all"} onClick={(e: any) => clearAllOnClick(e)}>Delete All</a>
        </div>
        <LoadingWrapper isLoading={isLoading} data-attribute="MyNotification_Default_LoadingWrapper">
        {myNotificationDetails?.notificationDetails?.length > 0 ? (
          <div className="card-block">
            {myNotificationDetails?.notificationDetails?.map(
              (item: any, index: any) => {
                const getText = ((html: any) => {
                  let divContainer = document.createElement("div");
                  divContainer.innerHTML = html;
                  let text = (divContainer?.childNodes[0]?.childNodes[0]?.childNodes[0]?.textContent + ", " + (divContainer?.childNodes[0]?.childNodes[0]?.childNodes[1]?.textContent != undefined ? divContainer?.childNodes[0]?.childNodes[0]?.childNodes[1]?.textContent + ",  " : "") + (divContainer?.childNodes[0]?.childNodes[1]?.textContent || divContainer?.childNodes[0]?.childNodes[0]?.childNodes[2]?.textContent) + ",  " + (divContainer?.childNodes[0]?.childNodes[2]?.textContent || divContainer?.childNodes[0]?.childNodes[0]?.childNodes[3]?.textContent));
                  return text || "";
                })
                return(
                <div className="card-details" key={index}>
                  <div className="order-icon-section">
                    <div className={item.icontype}>
                      <img src={item.iconBlobUrl} alt="" />
                    </div>
                  </div>
                  <div  className = "notificationClass">
                  <Tooltip content={getText(item?.notificationMessage)} data-attribute="MyNotification_Default_Tooltip">
                    <div
                    className={`order-detail-section click-notification-${index}`}
                    dangerouslySetInnerHTML={{
                      __html: item.notificationMessage,
                    }}
                  ></div>
                  </Tooltip>
                  </div>
                  <div className="order-date-section">
                    <p>{moment(new Date(item.created)).format(DATE_FORMAT)}</p>
                    <div
                      className="edit-delete-section"
                      onClick={() => setDeletePopup(item.sentNotificationId)}
                    >
                      <img
                        src={Delete}
                        alt=""
                        className="delete-icon fa-pencil"
                      />
                    </div>
                  </div>
                </div>
                )}
              )
            }
          </div>
        ) : (
          <div className="no-record-data">No Notification Available</div>
        )}
        </LoadingWrapper>
      </div>
      {deletePopup && (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete Notification"
          ModalPopupType="small"
          FooterSecondaryBtnTxt="cancel"
          FooterPrimaryBtnTxt="Delete"
          closeModalPopup={() => setDeletePopup(false)}
          PrimaryBtnOnclick={onDeleteConfirm}
          SecondryBtnOnclick={() => setDeletePopup(false)}
          ModalPopupName = "DeletePopUp-Alert"
         data-attribute="MyNotification_Default_ModalPopup">
          <p className="text-Delete">Are you sure you want to delete this notification ?</p>
        </ModalPopup>
      )}
      {deleteAllNotifications && (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete All Notifications"
          ModalPopupType="small"
          FooterSecondaryBtnTxt="cancel"
          FooterPrimaryBtnTxt="Delete"
          closeModalPopup={() => setDeleteAllNotification(false)}
          PrimaryBtnOnclick={onDeleteAllNotificationConfirmation}
          SecondryBtnOnclick={() => setDeleteAllNotification(false)}
          ModalPopupName = "DeletePopUp-Alert"
         data-attribute="MyNotification_Default_ModalPopup_2">
          <p className="text-Delete">Are you sure you want to delete all the notifications ?</p>
        </ModalPopup>
      )}
    </>
  );
};

export default MyNotification;
